
import vpsPageData from "../../data/vps";
import virtualServerPageData from "../../data/virtual-server";
import Calculator from "../../components/vps/calculator.vue";
import Customers from "../../components/vps/customers.vue";
import OsVr from "../../components/virtual-server/osVr.vue";
import Plans from "../../components/virtual-server/plans-virtual.vue";
import Benefits from "../../components/vps/benefits.vue";

import Modal from "../../components/rebranding/modal/Modal.vue";
import UsesVr from "../../components/virtual-server/usesVr.vue";
export default {
  components: {
    Calculator,
    OsVr,
    Customers,
    Plans,
    Benefits,
    Modal,
    UsesVr,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "خرید سرور مجازی | خرید VPS | وی پی اس لینوکس و ویندوز",
      meta: [
        {
          name: "description",
          content:
            "با خرید VPS آبالون همه امکانات سرور مجازی را در کنار قابلیت‌های پیشرفته سرور کلود شامل تغییر منابع حین سرویس، اطمینان و کیفیت بالاتر تجربه کنید.",
        },
        {
          name: "keywords",
          content:
            "خرید سرور مجازی, خرید VPS, سرور مجازی ابری, وی پی اس, خرید وی پی اس",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/virtual-server",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "خرید سرور مجازی | خرید VPS | وی پی اس لینوکس و ویندوز",
        },
        {
          property: "og:description",
          content:
            "با خرید VPS آبالون همه امکانات سرور مجازی را در کنار قابلیت‌های پیشرفته سرور کلود شامل تغییر منابع حین سرویس، اطمینان و کیفیت بالاتر تجربه کنید.",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/virtual-server",
        },
        {
          name: "twitter:creator",
          content: "@themetrades",
        },
        {
          name: "twitter:title",
          title: "خرید سرور مجازی | خرید VPS | وی پی اس لینوکس و ویندوز",
        },
        {
          name: "twitter:description",
          content:
            "با خرید VPS آبالون همه امکانات سرور مجازی را در کنار قابلیت‌های پیشرفته سرور کلود شامل تغییر منابع حین سرویس، اطمینان و کیفیت بالاتر تجربه کنید.",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/virtual-server",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "تفاوت سرور مجازی با سرور مجازی ابری چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سرور مجازی کلاد، امکاناتی پیشرفته‌تر شامل اطمینان و کیفیت سرویس بیشتر، افزایش منابع به میزان بسیار بالاتر و نیز امکان جایگزینی سخت‌افزار خراب با سالم به صورت خودکار و بدون وقفه در سرویس (به لطف Live Migration) را برایتان فراهم می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا می‌توان منابع سرور وی پی اس ابری را حین استفاده تغییر داد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. با توجه به این‌که VPS آبالون از تکنولوژی زیرساخت کلاد بهره می‌برد، امکان افزایش یا کاهش منابع حین سرویس فراهم است.",
                },
              },
              {
                "@type": "Question",
                name: "سیستم‌عامل وی پی اس آبالون چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "آبالون در خرید سرور مجازی، امکان انتخاب نسخه‌های مختلف ویندوز یا نسخه‌ها و توزیع‌های متنوع لینوکس از جمله Ubuntu ،Debian ،Fedora و CentOS را در اختیارتان می‌گذارد.",
                },
              },
              {
                "@type": "Question",
                name: "آیا استفاده از سرور مجازی آبالون نیاز به تخصص دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "خیر. پس از خرید VPS با سیستم‌عامل ویندوز کافی‌ست، از طریق کنسول تحت وب به سرور خود متصل شوید و پس از طی کردن مراحت تغییر پسورد ادمین، کانکشن های بعدی را از طریق همین کنسول یا از طریق ریموت دسکتاپ برقرار نمایید. در مورد سیستم‌عامل‌های لینوکس هم می‌توانید از طریق کنسول تحت وب یا SSH ارتباط را برقرار نمایید.",
                },
              },
              {
                "@type": "Question",
                name: "آیا می‌توان وی پی اس را خاموش، روشن یا ری‌استارت کرد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. پنل مدیریت سرور، امکان خاموش، روشن و ری‌استارت کردن سرور را در اختیارتان قرار می‌دهد.",
                },
              },
              {
                "@type": "Question",
                name: "آیا می‌توان سرور مجازی را بازسازی کرد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. با بازسازی VPS، حتی حین سرویس می‌توانید هر سیستم‌عامل دلخواه را انتخاب کنید تا مجدد روی سرور شما نصب شده و تحویل‌تان داده شود. توجه داشته باشید که با بازسازی سرور، اطلاعاتی که روی سیستم‌عامل قبلی داشتید، به صورت کامل حذف می‌شود.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "سرور مجازی ابری آبالون",
            },
            author: {
              "@type": "Person",
              name: "Hamid Karimi",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
  data() {
    return {
      title: "آبالون: ارائه دهنده سرویس‌های ابری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      benefits: vpsPageData.benefits,
      dataBlog: vpsPageData.dataBlog,
      questions: virtualServerPageData.questions,
      PopularServices: virtualServerPageData.PopularServices,
      uses: virtualServerPageData.uses,
      usesg: virtualServerPageData.usesg,
      locations: virtualServerPageData.locations,
      serviceFeatures: virtualServerPageData.serviceFeatures,
      activeSection: "",
      showmore: false,
    };
  },
  mounted() {},
  methods: {
    showMore() {
      this.showmore = true;
    },
    spliceNumber(number) {
      if (number != null) {
        number = Math.round(number);
        return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
    },
    handleScroll(e) {
      var sectionsElement = document.getElementsByClassName("sections")[0];

      if (sectionsElement) {
        if (document.documentElement.scrollTop > 550) {
          document.getElementsByClassName("sections")[0].classList =
            "sections d-flex align-center floating";
        } else {
          document.getElementsByClassName("sections")[0].classList =
            "sections d-flex align-center";
        }
      }
    },
  },
};
